import React, { useState } from "react";
import styled from "styled-components";
//COMPONENTS
import message from "components/common/message";
// APOLLO
import { useMutation } from "react-apollo";
import GET_PRESIGNED_URL from "ApolloClient/Mutations/getPresignedUploadUrl";

const UploadLabel = styled.label`
  font-weight: 900;
  font-size: 18px;
  margin-right: 8px;
`;

const UploadValue = styled.a`
  font-weight: 700;
  font-size: 16px;
`;

const TemplateDL = styled.a`
  font-weight: 700;
  font-size: 16px;
  text-decoration: underline !important;
  margin-left: 16px;
  /* color: ${(p) => p.theme.colors.neutral7} !important; */
`;

const UploadButton = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;

const Label = styled.label`
  font-weight: 600;
  color: ${(p) => p.theme.colors.primary4};
  border-radius: 25px;
  text-decoration: underline;
  background: transparent;
  display: inline-block;
  cursor: pointer;
`;

export default ({ label = "W9", templateUrl, file, onChange }) => {
  const [getPresignedUrl] = useMutation(GET_PRESIGNED_URL);
  const [uploading, setUploading] = useState(false);

  const onNewUpload = async (e) => {
    try {
      const file = e.target.files && e.target.files[0];
      if (!file) return;

      setUploading(true);

      // Get presigned URL from S3
      const presignedUrlResult = await getPresignedUrl({
        variables: {
          contentType: file.type || "application/octet-stream",
        },
      });

      if (!presignedUrlResult?.data?.getPresignedUploadUrl?.url) {
        throw new Error("Failed to get upload URL");
      }

      const { url } = presignedUrlResult.data.getPresignedUploadUrl;

      // Upload file directly to S3
      const uploadResponse = await fetch(url, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": file.type || "application/octet-stream",
        },
      });

      if (!uploadResponse.ok) {
        throw new Error("Upload failed");
      }

      // Extract the key from the presigned URL
      const key = url.split("?")[0].split("/").pop();

      // Create file metadata object
      const fileData = {
        filename: file.name,
        mimetype: file.type || "application/octet-stream",
        key,
        url: url.split("?")[0], // Use the base URL without query parameters
      };

      onChange(fileData);
      message.success("Upload successful");
      setUploading(false);
    } catch (err) {
      setUploading(false);
      console.error("Upload error:", err);
      message.error("Upload failed");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: 64,
        marginTop: 16,
      }}
    >
      <div>
        <div style={{ maginBottom: 16 }}>
          <UploadLabel>{label}:</UploadLabel>
          {file && file.filename ? (
            <UploadValue>{file.filename}</UploadValue>
          ) : (
            <span>No file selected</span>
          )}
        </div>
        <span>
          <UploadButton
            name={label}
            type="file"
            disabled={uploading}
            id={label}
            onChange={onNewUpload}
          />
          <Label htmlFor={label}>
            {!uploading ? "UPLOAD NEW" : "UPLOADING..."}
          </Label>
        </span>
        {templateUrl && (
          <TemplateDL target="_blank" download href={templateUrl}>
            DOWNLOAD TEMPLATE
          </TemplateDL>
        )}
      </div>
    </div>
  );
};
